import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';

export const HEIGHT: number = gridSize * 8;
export const NAME = 'ANNOUNCEMENT' as const;
